export default "__VITE_ASSET__DGlgUyeF__"